import { render, staticRenderFns } from "./SupervisorImports.vue?vue&type=template&id=44f5004c"
import script from "./SupervisorImports.vue?vue&type=script&lang=js"
export * from "./SupervisorImports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports